export default "__VITE_ASSET__xdnHuDjc__"